import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import EntraIdAuthProvider from './EntraId/EntraIdAuthProvider';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export default function AuthentificationProvider (
    { instance, children }:
    { instance: any, children: React.ReactNode }) {
    
    // Fetch auth type from tenant config
    const tenantConfig = useSelector(
        (state: RootState) => state.tenantConfig.config
    );

    if (tenantConfig.authentication === undefined) {
        return null; // Return null while configuration is being loaded to prevent a looping reload
    }


    if (tenantConfig.authentication === 'entraid') {
        return (
            <MsalProvider instance={instance as PublicClientApplication}>
                <EntraIdAuthProvider>
                    {children}
                </EntraIdAuthProvider>
            </MsalProvider>
        );
    }

    // 'none' and 'account' (H-3a — no wall enforcement in F1) render the app
    // directly; the account login lives on its own routes.
    return <>{children}</>;
};